import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import colors from "../../../utils/colors";
import { getAge } from "../utils";

const PatientDemographic = ({ patient }) => {
  return (
    <Box
      boxShadow="1px 4px 15px 0px #3030301F"
      p={{ base: "24px 16px", md: "50px 20px 20px 40px" }}
      borderRadius="10px"
      flex="1"
      bg="white"
    >
      <Text
        fontFamily="lato"
        fontWeight={400}
        fontSize={{ base: "16px", md: "18px" }}
        lineHeight="21.6px"
        color="black"
        mb="24px"
      >
        Basic Information
      </Text>

      <Flex
        direction={{ base: "column", md: "row" }}
        gap={{ base: "24px", md: "40px" }}
        wrap="wrap"
      >
        {/* Column 1 */}
        <Box>
          <Box mb="24px">
            <LabelValue label="Age" value={getAge(patient?.dob)} />
          </Box>
          <Box>
            <LabelValue label="Gender" value={patient?.gender} />
          </Box>
        </Box>

        {/* Column 2 */}
        <Box>
          <Box mb="24px">
            <LabelValue label="Phone number" value={patient?.phone} />
          </Box>
          <Box>
            <LabelValue label="Email Address" value={patient?.email} />
          </Box>
        </Box>

        {/* Column 3 */}
        <Box>
          <Box mb="24px">
            <LabelValue
              label="Height"
              value={patient?.height ? `${patient.height} cm` : "N/A"}
            />
          </Box>
          <Box>
            <LabelValue
              label="Weight"
              value={patient?.weight ? `${patient.weight} kg` : "N/A"}
            />
          </Box>
        </Box>

        {/* Column 4 */}
        <Box>
          <Box mb="24px">
            <LabelValue label="Blood Group" value={patient?.bloodGroup} />
          </Box>
          <Box>
            <LabelValue label="Genotype" value={patient?.genotype} />
          </Box>
        </Box>

        {/* Column 5 */}
        <Box>
          <Box mb="24px">
            <LabelValue label="Date Registered" value={patient?.date} />
          </Box>
          <Box>
            <LabelValue label="Address" value={patient?.address} />
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

const LabelValue = ({ label, value }) => (
  <>
    <Text
      fontFamily="lato"
      fontWeight={400}
      fontSize="16px"
      lineHeight="19px"
      color={colors.placeholderColor}
      mb="5px"
    >
      {label}
    </Text>
    <Text
      fontFamily="lato"
      fontWeight={400}
      fontSize="16px"
      lineHeight="19px"
      color={colors.dark}
    >
      {value}
    </Text>
  </>
);

export default PatientDemographic;
